import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

import { SharedService } from "../../shared/shared.service";
import { ActionStatusService } from "../../shared/action-status.service";
import { ActionStatus } from "../../shared/action-status";

@Component({
  selector: 'app-dasara-festival',
  templateUrl: './dasara-festival.component.html',
  styleUrls: ['./dasara-festival.component.css']
})
export class DasaraFestivalComponent implements OnInit {

  constructor(private router: Router
    , private sharedService: SharedService
    , private actionStatusService: ActionStatusService) { }

  pdfName: string = "marathi";
  pdfdownloading: boolean = false;
  ngOnInit() {

    let devoteeDetail = this.sharedService.getDevoteeDataAtLocStorage();


    let actionStatus = new ActionStatus();
    actionStatus.MobileNo = devoteeDetail.MobileNo;
    actionStatus.Comment = new Date().toString();
    actionStatus.ActionId = 7;
    actionStatus.Status = 1;

    //this.sharedService.showSpinner();
    this.actionStatusService.save(actionStatus).subscribe(
      data => console.log(data),
      err => console.log(err.error.Message),
      () => {
        //this.sharedService.hideSpinner();
      }
    )

  }

  downloadingPDF() {
    this.pdfdownloading = true;
  }



}



// WEBPACK FOOTER //
// ./src/app/devotee/dasara-festival/dasara-festival.component.ts